import Swiper from "swiper";
import { A11y, Navigation } from "swiper/modules";
import debounce from "../../utils/debounce";

class BlogPostList {
  private carousel: HTMLElement;
  private mediaQuery: MediaQueryList;
  private swiperCarousel: Swiper | null = null;
  private slideWrapper: HTMLElement;
  private slides: Element[];
  constructor(carousel: HTMLElement) {
    this.carousel = carousel;
    this.slideWrapper = this.carousel.querySelector(
      ".swiper-wrapper"
    ) as HTMLElement;
    this.slides = Array.from(this.slideWrapper.children);
    this.mediaQuery = window.matchMedia("(max-width: 47.9375rem)");
    this.init();
  }

  init(): void {
    const debouncedHandelMediaQueryChange = debounce(
      this.handelMediaQueryChange.bind(this),
      100
    );

    window.addEventListener("resize", debouncedHandelMediaQueryChange);

    if (this.mediaQuery.matches) {
      this.initSwiper();
    }
  }

  private setupSlides(): void {
    this.slides.forEach((slide) => {
      slide.classList.add("swiper-slide");
    });
  }

  private handelMediaQueryChange(): void {
    if (this.mediaQuery.matches) {
      this.initSwiper();
    } else {
      this.destroySwiper();
    }
  }

  private initSwiper(): void {
    this.setupSlides();
    this.swiperCarousel = new Swiper(this.carousel, {
      modules: [Navigation, A11y],
      navigation: {
        nextEl: this.carousel.querySelector(
          ".swiper-button-next"
        ) as HTMLElement,
        prevEl: this.carousel.querySelector(
          ".swiper-button-prev"
        ) as HTMLElement,
      },
    });
  }

  private destroySwiper(): void {
    if (this.swiperCarousel) {
      this.swiperCarousel.destroy(true, true);
      this.carousel.classList.remove("swiper-backface-hidden");
      this.slideWrapper.removeAttribute("aria-live");
      this.slides.forEach((slide) => {
        slide.classList.remove("swiper-slide");
        slide.removeAttribute("role");
        slide.removeAttribute("aria-label");
      });
    }
  }
}

document.querySelectorAll("[blog-post-slider]").forEach((carousel) => {
  new BlogPostList(carousel as HTMLElement);
});
